export default {
    name: 'track-click',
    directive: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const handler = (e) => {
          if (el === e.target) {
            binding.value(e)
          }
        }
        el.__vueTrackClick__ = handler
  
        // add Event Listeners
        document.addEventListener('click', handler)
      },
  
      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueTrackClick__)
        el.__vueTrackClick__ = null
      }
    }
  }
  